import React, { useEffect, useState } from 'react';
import './Fireworks.css';

function Fireworks({ trigger, position }) {
  const [particles, setParticles] = useState([]);

  useEffect(() => {
    if (trigger) {
      // Create 12 particles for the fireworks effect
      const newParticles = Array.from({ length: 12 }, (_, i) => {
        const angle = (i * 360) / 12;
        const angleRad = (angle * Math.PI) / 180;
        const distance = 60;
        return {
          id: i,
          angle: angle,
          endX: Math.cos(angleRad) * distance,
          endY: Math.sin(angleRad) * distance
        };
      });
      setParticles(newParticles);
      
      // Reset after animation completes
      const timer = setTimeout(() => {
        setParticles([]);
      }, 1600);
      
      return () => clearTimeout(timer);
    }
  }, [trigger]);

  if (particles.length === 0) return null;

  return (
    <div 
      className="fireworks-container"
      style={{
        left: `${position.x}px`,
        top: `${position.y}px`
      }}
    >
      {particles.map(particle => (
        <div
          key={particle.id}
          className="firework-particle"
          style={{
            '--end-x': `${particle.endX}px`,
            '--end-y': `${particle.endY}px`
          }}
        />
      ))}
    </div>
  );
}

export default Fireworks;

